/**
 * Reserved field name that is used to communicate general errors from back-end
 */
export const GENERAL_ERROR_FIELD_NAME = 'registrationCompanyData';
